import { render } from "./PerviewImageModal.vue?vue&type=template&id=32d7560f&scoped=true"
import script from "./PerviewImageModal.vue?vue&type=script&lang=js"
export * from "./PerviewImageModal.vue?vue&type=script&lang=js"

import "./PerviewImageModal.vue?vue&type=style&index=0&id=32d7560f&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d7560f"]])

export default __exports__